import { useState, useEffect } from "react"
import { useNavigate } from 'react-router-dom';
import { lang, img_url, chk_img, gotoLink, thDateFormat, enDateFormat } from '../lang'
import api from '../api'
import classes from '../../assets/css/calendar.module.css'
import Calendar from "../Booking/Calendar"
import DayCalendar from "../Booking/DayCalendar"
import Alert from "sweetalert2";

export default function HomeCalendar(props) {
    const {styles, init} = props;
    const [vdo, setVdo] = useState([]);
    const navigate = useNavigate();

    const [assistants, setAssistants] = useState([]);
    const [bookings, setBookings] = useState([]);
    const [events, setEvents] = useState([]);
    const [calendar_mode, setCalendarMode] = useState("monthly"); 
    const [rooms, setRooms] = useState([]);
    const [select_date, setSelectDate] = useState(new Date().toISOString().split('T')[0]);

    useEffect(()=>{
        const fetchInit = async () =>{
            try {
                const asst_response = await api.get('/assistants');
                setAssistants(asst_response.data.results);
                const room_response = await api.get('/room');
                setRooms(room_response.data.results);
                const response = await api.get('/vdos/1?show=1');
                setVdo(response.data.results);
            } catch (err) {
                if(err.response){
                    //Not in 202 response range
                    console.log(err.response.data);
                    console.log(err.response.headers);
                    console.log(err.response.status);
                } else {
                    console.log(`Error: ${err.message}`);
                }
            }
        }
        fetchInit();
        fetchData();
    },[]);

    const fetchData = async () =>{
        try {
            const response = await api.get('/rsvn?cancel=0');
            const results = response.data.results;
            let all_events = [];
            results.forEach(element => {
                let item = {
                    title: lang(element.room_name,element.room_name_en),
                    start  : element.booking_date+'T'+element.start_time+':00',
                    end  : element.booking_date+'T'+element.end_time+':00',
                    item  : element,
                    type  : "booking",
                    allDay : false

                }
                all_events.push(item);
            });
            setBookings(results);

            const asst_response = await api.get('/assistant-bookings?cancel=0');
            const asst_results = asst_response.data.results;
            asst_results.forEach(element => {
                let item = {
                    title: "นัดหมายตรวจรายงาน",
                    start  : element.booking_date+'T'+element.start_time,
                    end  : element.booking_date+'T'+element.end_time,
                    item  : element,
                    type  : "asst_booking",
                    allDay : false

                }
                all_events.push(item);
            });
            
            const holiday_response = await api.get('/holiday');
            const holiday_results = holiday_response.data.results;
            holiday_results.forEach(element => {
                let item = {
                    title: lang(element.detail,element.detail_en),
                    start: element.start+'T00:00:01',
                    end  : element.end+'T23:59:59',
                    item  : element,
                    type  : "holiday",
                    allDay : true

                }
                all_events.push(item);
            });
            setEvents(all_events);
        } catch (err) {
            if(err.response){
                //Not in 202 response range
                console.log(err.response.data);
                console.log(err.response.headers);
                console.log(err.response.status);
            } else {
                console.log(`Error: ${err.message}`);
            }
        }
    }

    const dateClick = (info) => {
        // console.log(new Date(info.dateStr+" 12:00:00"));
        setSelectDate(new Date(info.dateStr+" 12:00:00"));

        setCalendarMode("daily");
    }
    
    /**
     * when we click on event we are displaying event details
     */
    const eventClick = (eventClick) => {
        if(eventClick.event.extendedProps.type==="booking"){
            let item = eventClick.event.extendedProps.item;
            let more_detail = '';
            if(item.title){
                more_detail = `
                <tr>
                    <td>${lang('รายละเอียด','Info')}</td>
                    <td><strong>${item.title}</strong></td>
                </tr>`;
            }
            Alert.fire({
                title: eventClick.event.title,
                html:
                    `<div class="table-responsive">
                <table class="table">
                <tbody>
                    <tr>
                        <td>${lang('รายการ','Title')}</td>
                        <td><strong>` + eventClick.event.title + `</strong></td>
                    </tr>
                    <tr>
                        <td>${lang('วันที่','Date')}</td>
                        <td><strong>` + lang(thDateFormat(item.booking_date),enDateFormat(item.booking_date)) + `</strong></td>
                    </tr>
                    <tr>
                        <td>${lang('เวลา','Time')}</td>
                        <td><strong>` + item.start_time + ' - ' + item.end_time + `</strong></td>
                    </tr>
                    <!--<tr>
                        <td>${lang('จองโดย','Booking by')}</td>
                        <td><strong>` + item.booking_by + `</strong></td>
                    </tr>-->
                    <tr>
                        <td>${lang('เหตุผล','reason')}</td>
                        <td><strong>` + item.reason + `</strong></td>
                    </tr>` + more_detail + `
                </tbody>
                </table>
                </div>`,

                showDenyButton: false,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonColor: "#3085d6",
                denyButtonColor: "#d33",
                confirmButtonText: lang("ปิดหน้าต่าง","Close"),
                cancelButtonText: lang("กลับหน้าหลัก","Back"),
                denyButtonText: lang("ยกเลิกการจอง","Cancel"),
            }).then(result => {
                // if (result.isConfirmed) {
                // //   eventClick.event.remove(); // It will remove event from the calendar
                //     openModal(item.id);
                // }else if (result.isDenied) {
                //     //   eventClick.event.remove(); // It will remove event from the calendar
                //         openRmModal(item.id);
                //     }
            });
         }else if(eventClick.event.extendedProps.type==="asst_booking"){
            let item = eventClick.event.extendedProps.item;
            let more_detail = '';
            if(item.title){
                more_detail = `
                <tr>
                    <td>รายละเอียด</td>
                    <td><strong>${item.title}</strong></td>
                </tr>`;
            }
            Alert.fire({
                title: eventClick.event.title,
                html:
                    `<div class="table-responsive">
                <table class="table">
                <tbody>
                    <tr>
                        <td>ผู้สอน</td>
                        <td><strong>` + item.assistant_name + `</strong></td>
                    </tr>
                    <tr>
                        <td>วันที่</td>
                        <td><strong>` + thDateFormat(item.booking_date) + `</strong></td>
                    </tr>
                    <tr>
                        <td>เวลา</td>
                        <td><strong>` + item.start_time.substr(0,5) + ' - ' + item.end_time.substr(0,5)  + ` น.</strong></td>
                    </tr>
                    <tr>
                        <td>นัดหมายโดย</td>
                        <td><strong>` + item.booking_by + `</strong></td>
                    </tr>` + more_detail + `
                </tbody>
                </table>
                </div>`,

                showDenyButton: false,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonColor: "#3085d6",
                denyButtonColor: "#d33",
                confirmButtonText: "ปิดหน้าต่าง",
                cancelButtonText: "กลับหน้าหลัก",
                denyButtonText: 'ยกเลิกการนัดหมาย',
            }).then(result => {
                // if (result.isConfirmed) {
                // //   eventClick.event.remove(); // It will remove event from the calendar
                //     openModal(item.id);
                // }else if (result.isDenied) {
                //     //   eventClick.event.remove(); // It will remove event from the calendar
                //         openRmModal(item.id);
                //     }
            });
        }else if(eventClick.event.extendedProps.type==="asst_booking"){
            let item = eventClick.event.extendedProps.item;
            let more_detail = '';
            if(item.title){
                more_detail = `
                <tr>
                    <td>รายละเอียด</td>
                    <td><strong>${item.title}</strong></td>
                </tr>`;
            }
            Alert.fire({
                title: eventClick.event.extendedProps.title,
                html:
                    `<div class="table-responsive">
                <table class="table">
                <tbody>
                    <tr>
                        <td>ผู้สอน</td>
                        <td><strong>` + item.assistant_name + `</strong></td>
                    </tr>
                    <tr>
                        <td>วันที่</td>
                        <td><strong>` + thDateFormat(item.booking_date) + `</strong></td>
                    </tr>
                    <tr>
                        <td>เวลา</td>
                        <td><strong>` + item.start_time.substr(0,5) + ' - ' + item.end_time.substr(0,5)  + ` น.</strong></td>
                    </tr>
                    <tr>
                        <td>นัดหมายโดย</td>
                        <td><strong>` + item.booking_by + `</strong></td>
                    </tr>` + more_detail + `
                </tbody>
                </table>
                </div>`,
                showDenyButton: false,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonColor: "#3085d6",
                denyButtonColor: "#d33",
                confirmButtonText: "ปิดหน้าต่าง",
                cancelButtonText: "กลับหน้าหลัก",
                denyButtonText: 'ยกเลิกการนัดหมาย',
            }).then(result => {
            });
        }else{
            let item = eventClick.event.extendedProps.item;
            let holiday = lang(thDateFormat(item.start),enDateFormat(item.start)) + ' - ' + lang(thDateFormat(item.end),enDateFormat(item.end));
            if(item.start === item.end){
                holiday = lang(thDateFormat(item.start),enDateFormat(item.start));
            }
            Alert.fire({
                title: eventClick.event.title,
                html:
                    `<div class="table-responsive">
                <table class="table">
                    <tbody>
                        <tr>
                            <td>${lang('รายการ','Title')}</td>
                            <td><strong>` + eventClick.event.title + `</strong></td>
                        </tr>
                        <tr>
                            <td>${lang('วันที่','Date')}</td>
                            <td><strong>` + holiday + `</strong></td>
                        </tr>
                    </tbody>
                </table>
                </div>`,
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonColor: "#3085d6",
                cancelButtonText: lang("ปิดหน้าต่าง","Close")
            }).then(result => {
            });
        }
    };

    // a custom render function
    function renderEventContent(eventInfo) {
        var e = document.getElementsByClassName('fc-col-header-cell-cushion');
        if(e){
            Array.from(e).forEach(element => {
                if(element.localName==="a"){
                    let d = document.createElement('div');
                    d.innerHTML = element.innerHTML;
                    element.parentNode.innerHTML=d.innerHTML;
                }
            });
        }
        let type = eventInfo.event.extendedProps.type;
        return (
        <>
            {(type==='booking')?<div className="fc-event-dot"></div>:''}
            <div className="fc-event-time">{eventInfo.timeText}</div>
            <div className="fc-event-title">{eventInfo.event.title}</div>
        </>
        )
    }

  return (
    <div className={"container "+styles["calendar"]}>
        <div className={styles["calendar-detail"]}>
            <div className={styles["vdo"]}></div>
            <div className={styles["calendar-group"]}>
                <h2>{lang("ตารางการใช้","Room Reservation ")}<span>{lang("ห้องอ่านเดี่ยว/ห้องอ่านกลุ่ม","Calendar")}</span></h2>
                <div className={classes["calendar"]+" calendar "+styles["frame"]}>
                    {(calendar_mode==="daily")?(
                        <DayCalendar select_date={select_date} styles={classes} showButton={true} assistants={assistants}  rooms={rooms} all_events={events} setCalendarMode={setCalendarMode}
                        />
                    ):(
                        <Calendar setCalendarMode={setCalendarMode} events={events} showButton={true} eventClick={eventClick} renderEventContent={renderEventContent} dateClick={dateClick}/>
                    )}
                </div>
            </div>
        </div>
        {/* <div className={styles["vdo-detail"]+" reveal"}>
            {vdo.map((item, index) => (
                <div className={styles["card"]} key={'vdo-'+index} onClick={e=>gotoLink(item.link)}>
                    <img src={chk_img(item.cover_img)} alt={lang(item.name_th,item.name_en)} width="675" height="380" />
                    <div className={styles["card-end"]}></div>
                </div>
            ))}
        </div> */}
    </div>
  )
}
